import CCPieChart from "../Common/CCPieChart";
import {prepareBuffer} from "../../util/Buffer";

class ExamplePieChart extends CCPieChart {
    constructor(props) {
        super(props);

        this.state.fetchBackgroundOperation = false
    };

    componentDidMount() {
        super.componentDidMount();

        const sliceData = [
            {id: 0, value: 30, label: 'Page A'},
            {id: 1, value: 22, label: 'Page B'},
            {id: 2, value: 18, label: 'Page C'},
            {id: 3, value: 15, label: 'Page D'},
            {id: 4, value: 10, label: 'Page E'},
            {id: 5, value: 5,  label: 'Page F'},
        ];

        let series = structuredClone(this.props.Series ?? [{}]);
        series[0].data = sliceData;

        this.setState({Loading: this.state.fetchBackgroundOperation, Series: series});

        this.applet.getEnterpriseComponent().executeQuery(1,100000);
    }

    enterpriseComponentLoadStarted = () => {
        this.setState({Loading: true});
    };

    enterpriseComponentLoadCompleted = (ec) => {
        let buffer = prepareBuffer(ec);

        let series = structuredClone(this.state.Series);
        if (series.length === 0) {
            series = [{data: []}]
        }
        series[0].data = []
        for (let i = 0; i < buffer.length; i++) {
            series[0].data.push({
                id: i,
                value: parseFloat(buffer[i].get("Y_AXIS_1")),
                label: buffer[i].get("X_AXIS"),
            });
        }

        this.setState({Loading: false, Series: series});
    };
}

export default ExamplePieChart;
